import { render, staticRenderFns } from "./opetajad.vue?vue&type=template&id=2eb21960&"
import script from "./opetajad.vue?vue&type=script&lang=js&"
export * from "./opetajad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports